export const logAddToCart = (event, items) => {
  // due to custom being used in both event and event.ga below is needed
  let custom = event.custom && { ...event.custom };
  custom = {
    ...custom,
    ...(event.ga && event.ga.custom),
  };
  typeof window.sendEvent === "function" &&
    window.sendEvent({
      name: "add_to_cart",
      event_label: event.source,
      ...(custom && { custom }),
      params: {
        currency: items.currency,
        items: items.map((item, index) => {
          let mergedItem;
          // add attributes from GA event
          if (event.ga && event.ga.items) {
            mergedItem = { ...event.ga.items[index] };
          }
          mergedItem = {
            ...mergedItem,
            // overide GA event attributes if they already exist
            id: item.productNumber,
            price: item.productPrice,
            quantity: item.quantity,
            ratings: item.ratings,
          };
          return mergedItem;
        }),
      },
    });
};

export const logAddToList = (event) =>
  typeof window.sendEvent === "function" &&
  window.sendEvent({
    event_category: "ecommerce",
    event_action: "add_to_wishlist",
    event_label: event.source,
    custom: {
      item_number_event: event.productNumber,
      item_type_event: event.productType,
    },
    items: [
      {
        quantity: event.quantity,
      },
    ],
  });

export const logAddToCartFail = (errorMessage) =>
  typeof window.sendEvent === "function" &&
  window.sendEvent({
    event_category: "error",
    event_action: "add_to_cart",
    event_label: errorMessage,
    custom: {
      error_id: "ADD_TO_CART_ERROR",
    },
  });

export const logAddToListFail = (errorMessage) =>
  typeof window.sendEvent === "function" &&
  window.sendEvent({
    event_category: "error",
    event_action: "add_to_wishlist",
    event_label: errorMessage,
    custom: {
      error_id: "ADD_TO_WISHLIST_ERROR",
    },
  });
